<template>
  <div>
    <p class="cm-mg-p-wzd">3.1 {{ $t('devices.sensor_associated_info') }}</p>
    <hr />
    <div class="row">
      <div class="col-12">
        <div class="form-group has-label">
          <label class="text-transform-none"
            >{{ $t('common_words.select_companies') }} *</label
          >
          <br />
          <el-select
            @change="selectAllFromSelect('model.business_ids', businesses)"
            clearable
            multiple
            filterable
            class="select-primary custom-width-select bus-rels shadow-sm"
            size="large"
            v-model="model.business_ids"
            :placeholder="`${$t('common_words.select')}...`"
          >
            <el-option
              v-for="(option, index) in businesses"
              class="select-primary selected-all"
              :value="option.id"
              :label="option.name"
              :key="`bs-${option.name}-${index}`"
            ></el-option>
          </el-select>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="form-group has-label">
          <label class="text-transform-none">{{
            $t('common_words.select_one_or_many_farms')
          }}</label>
          <br />
          <el-select
            @change="selectAllFromSelect('model.farm_ids', farms)"
            clearable
            multiple
            filterable
            class="select-primary custom-width-select shadow-sm"
            size="large"
            v-model="model.farm_ids"
            :placeholder="`${$t('common_words.select')}...`"
          >
            <el-option
              v-for="(option, indexFarm) in farms"
              class="select-primary selected-all"
              :value="option.id"
              :label="option.name"
              :key="`fr-${option.name}-${indexFarm}`"
            ></el-option>
          </el-select>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="form-group has-label">
          <label class="text-transform-none">{{
            $t('devices.select_one_or_many_stations')
          }}</label>
          <br />
          <el-select
            @change="selectAllFromSelect('model.station_ids', stations)"
            clearable
            multiple
            filterable
            class="select-primary custom-width-select shadow-sm"
            size="large"
            v-model="model.station_ids"
            :placeholder="`${$t('common_words.select')}...`"
          >
            <el-option
              v-for="(option, indexStation) in stations"
              class="select-primary selected-all"
              :value="option.id"
              :label="option.name"
              :key="`st-${option.name}-${indexStation}`"
            ></el-option>
          </el-select>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import store from '@/store';
import SweetAlert from 'src/class/Alerts';
import MixinPermissions from 'src/util/mixinPermissions';
import mixinMasters from 'src/util/mixinMasters';
import MixinForm from 'src/mixins/forms/mixin-form';
import { Axios } from 'src/class/Axios.js';

export default {
  data() {
    return {
      model: {
        business_ids: null,
        farm_ids: null,
        station_ids: null,
      },
      businesses: null,
      farms: null,
      stations: null,
    };
  },
  mixins: [MixinPermissions, MixinForm, mixinMasters],
  watch: {
    '$i18n.locale': 'getSelectAll',
  },
  methods: {
    getSelectAll() {
      this.businesses = this.concatAll(this.businesses.splice(1));
      this.farms = this.concatAll(this.farms.splice(1));
      this.stations = this.concatAll(this.stations.splice(1));
    },
    validate() {
      return this.$validator
        .validateAll()
        .then((res) => {
          this.$emit('on-validated', res, this.model);

          let others = [];
          this.businesses.forEach((item) => {
            this.model.business_ids.forEach((element) => {
              if (element == item.id) {
                others.push(item.name);
              }
            });
          });

          let othersF = [];
          this.farms.forEach((item) => {
            this.model.farm_ids.forEach((element) => {
              if (element == item.id) {
                othersF.push(item.name);
              }
            });
          });

          let othersSt = [];
          this.stations.forEach((item) => {
            this.model.station_ids.forEach((element) => {
              if (element == item.id) {
                othersSt.push(item.name);
              }
            });
          });

          this.$emit('fillSensorForm', 'thirdStep', {
            names_business: others,
            names_farms: othersF,
            names_stations: othersSt,
          });
          return res;
        })
        .then((resp) => {
          if (!resp) return false;

          if (this.model.business_ids.length == 0) {
            for (let index of document.getElementsByClassName('bus-rels')) {
              let sel = index.getElementsByClassName('el-input__inner')[0];
              sel.focus();
              sel.classList.add('custom-has-error');
              store.dispatch('utils/removeHasError', sel);
            }
            return false;
          } else return true;
        });
    },
  },

  created() {
    if (this.isCreate() || this.isUpdate()) {
      this.showHideLoading(true);

      Axios.getMasters('businesses')
        .then((response) => {
          this.businesses = this.concatAll(response.data.data);

          if (!sessionStorage.getItem('editForm')) {
            this.model.business_ids = this.selectElementsAsignFromModel(
              1,
              this.model.business_ids,
              this.businesses
            );

            if (
              this.model.business_ids === null &&
              this.businesses.length == 1
            ) {
              this.model.business_ids.push(this.businesses[0].id);
            }

            try {
              this.model.business_ids = [...new Set(this.model.business_ids)];
            } catch (error) {}
          }

          this.showHideLoading();
        })
        .catch((error) => {
          this.showHideLoading();
          SweetAlert.warning(error.response.data.message);
        });

      Axios.getMasters('farms/farms/')
        .then((response) => {
          this.farms = this.concatAll(response.data.data);

          if (!sessionStorage.getItem('editForm') && this.farms.length == 1)
            this.model.farm_ids.push(this.farms[0].id);

          this.showHideLoading();
        })
        .catch((error) => {
          this.showHideLoading();
          SweetAlert.warning(error.response.data.message);
        });

      Axios.getMasters('devices/stations')
        .then((response) => {
          this.stations = this.concatAll(response.data.data);

          if (!sessionStorage.getItem('editForm') && this.stations.length == 1)
            this.model.station_ids.push(this.stations[0].id);

          this.showHideLoading();
        })
        .catch((error) => {
          this.showHideLoading();
          SweetAlert.warning(error.response.data.message);
        });
    } else this.showHideLoading();
  },

  mounted() {
    let editForm = {};
    if (this.isUpdate() && sessionStorage.getItem('editForm')) {
      editForm = JSON.parse(sessionStorage.getItem('editForm'));
      this.model.business_ids = [...new Set(editForm.business_ids)];
      this.model.farm_ids = [...new Set(editForm.farm_ids)];
      this.model.station_ids = [...new Set(editForm.station_ids)];
    }
  },
};
</script>
<style></style>
